import { ChevronDown } from "lucide-react";
import { usePropertyStore } from "../../store/propertyStore";

interface PropertySelectProps {
  className: string;
  chevronCls: string;
}

// One selector, rendered at several sizes — the two top bar breakpoints and the
// landing page that greets a user with nothing chosen. It used to be two copies
// of the same markup, and they drifted: the placeholder option reached one and
// not the other, so the desktop bar showed a property while nothing was
// selected. Add a size by passing classes, never by copying this.
export function PropertySelect({ className, chevronCls }: PropertySelectProps): JSX.Element {
  const { properties, selectedPropertyId, loading, selectProperty } = usePropertyStore();
  const empty = properties.length === 0 && !loading;

  return (
    <>
      <select
        aria-label="Selected property"
        value={selectedPropertyId ?? ""}
        // Nothing is auto-selected, so "" is a real resting state. Ignore it
        // rather than calling selectProperty(NaN).
        onChange={(e) => e.target.value && selectProperty(Number(e.target.value))}
        disabled={loading || empty}
        className={className}
      >
        {empty && <option value="">No properties</option>}
        {loading && <option value="">Loading...</option>}
        {/* Only the resting display before a choice is made: `disabled hidden`
            keeps it out of the open list, and once a property is picked it is
            not rendered at all — picking it again would do nothing. */}
        {!loading && !empty && selectedPropertyId === null && (
          <option value="" disabled hidden>Select a property</option>
        )}
        {properties.map((prop) => (
          <option key={prop.id} value={prop.id}>
            {prop.name}
          </option>
        ))}
      </select>
      <ChevronDown size={16} className={chevronCls} />
    </>
  );
}
